module.exports = "<ngx-loading-bar color=\"#ff8800\"></ngx-loading-bar>\n<router-outlet></router-outlet>\n\n"